<template>
	<div>
		<ChangeController :visible='dataChanged' @close='show=false' @revert='revert' @save='save' />
		
		<v-card>
			<v-card-text>
				
				<section class='mt-10 mb-10'>
					<TextEditor v-model='data.text' @show-change='dataChanged = true'  />
				</section>
				<section>
					<h2 class='mb-4'>SERVICE AND COVERAGE</h2>
					<TextEditor v-model='data.section1' @show-change='dataChanged = true'/>
				</section>
				<section>
					<h2 class='mb-4'>S-100 FREE TRIAL</h2>
					<TextEditor v-model='data.section2' @show-change='dataChanged = true'/>
				</section>
				<section>
					<h2 class='mb-4'>DISTRIBUTION, END-USER SYSTEMS & SECURITY</h2>
					<TextEditor v-model='data.section3' @show-change='dataChanged = true'/>
				</section>
				<section class='mt-10 mb-10'>
					<h2 class='mb-4'>TIMELINE, ARTICLES & PROJECTS</h2>
					<TextEditor v-model='data.section4' @show-change='dataChanged = true'/>
				</section>
				<section class="mb-10">
					<h2 class="mb-4">File Attachments</h2>
					<Collection
						cols='auto'
						:collection="data.files"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.FileForm"
						title="File Attachment"
						breakpoints="xs12 sm3 md3 lg3 xl2"
						isFileUpload
					>
						<FileItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'

import Collection from '@/components/admin/ItemCollection'
import FileItem from '@/components/n-collections/n-items/FileItem'

import FileForm from '@/components/dialogs/forms/FileForm'

import DataMixin from '@/mixins/DataMixin'

export default {
	name: 'AdminS100',
	mixins: [DataMixin],
	FileForm,
	components: {
		TextEditor,
		Collection,
		FileItem
	},
}
</script>

<style lang="scss" scoped>
</style>